import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { CompanyActionContext } from '../../../common/types/CompanyActionContext';
import {
  WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB,
  WEB_COMPONENT_COMPANY_LICENSING_TAB,
  WEB_COMPONENT_COMPANY_MSP_IN_PRODUCT_TRIALS_TAB,
} from '../../../../webcomponents.constants';
import { ImageState } from '../../../../ui/gzImageRepo/types';

export const templateMyCompanyPanel = document.createElement('template');

templateMyCompanyPanel.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <gz-tab-group class='edit-company-tab-group' id='edit-company-tab-group'>
      <gz-tab id='company-details-tab'>
        <div id='company-details-form-wrapper'>
          <gz-company-details-tab context='${CompanyActionContext.Edit}'></gz-company-details-tab>
        </div>
      </gz-tab>

      <gz-tab id='authentication-tab'>
        <${WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB} context='${CompanyActionContext.Edit}'></${WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB}>
      </gz-tab>

      <gz-tab id='licensing-tab'>
        <${WEB_COMPONENT_COMPANY_LICENSING_TAB} context='${CompanyActionContext.Edit}'></${WEB_COMPONENT_COMPANY_LICENSING_TAB}>
      </gz-tab>

      <gz-tab id='msp-in-product-trials-tab'>
        <${WEB_COMPONENT_COMPANY_MSP_IN_PRODUCT_TRIALS_TAB} context='${CompanyActionContext.Edit}'></${WEB_COMPONENT_COMPANY_MSP_IN_PRODUCT_TRIALS_TAB}>
      </gz-tab>
    </gz-tab-group>

      <div class="edit-company-error">
      <gz-image-repo state="${ImageState.ERROR}">
          <gz-title fontSize="14" fontWeight="400" id="error-message" />
      </gz-image-repo>
    </div>
  </div>
`;
